import superagent from 'superagent';
import getCookie from './getCookie';

export default async function validateRFC({ valuesForm, type }) {
  //Validar RFC
  const { rfc } = valuesForm;
  const url = `${process.env.REACT_APP_WEBSERVICE_MX}/getEstatusrfcFacturama?rfc=${rfc}`;
  let response = '';
  await superagent
    .get(url)
    .set('Content-Type', 'application/json')
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .then((res) => {
      if (res.body) {
        response = res.body;
        return;
      } else {
        window.scrollTo(0, 0);
        alert('Error al validar RFC');
        return;
      }
    })
    .catch((err) => {
      console.log(err);
      window.scrollTo(0, 0);
      alert([
        'Por el momento no se pueden obtener los datos del RFC, por favor intenta mas tarde.',
      ]);

      return;
    });
  return response;
}
